import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/internal/operators';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';
import { GlobalSearchService } from './globalsearchservice.service';
import { DeviceService } from './device.service';

@Injectable({
	providedIn: 'root'
})
export class PaymentTermsService {
	config: any;
	user: any = [];

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		})
	};

	private updateHeaders() {
		const uuid = this.deviceService.getDeviceUUID();
		let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		if (this.config && this.config.apiCredentials && this.config.apiCredentials.clientId && this.user && this.user.user && this.user.user.userid) {
			headers = headers.set('Authorization', 'Bearer ' + this.config.apiCredentials.clientId + '_' + this.user.user.userid);
		}
		headers = headers.set('X-Device-UUID', uuid);
		this.httpOptions.headers = headers;
	}

	constructor(
		private http: HttpClient,
		private _configSvc: RuntimeConfigLoaderService,
		private globalSearchService: GlobalSearchService,
		private deviceService: DeviceService
	) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.updateHeaders();
		});
		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
			this.updateHeaders();
		});
		this.updateHeaders();
	}

	public runBatch() {
		const method = 'payments/paymentterms/batch/trigger';
		return this.http.post(this.setEndPoint(method), {}, this.httpOptions).pipe(
			catchError(this.handleError('runBatch', {}))
		);
	}

	public getBatchStatus(batchId: any) {
		const method = 'payments/paymentterms/batch/status&batch_log_id=' + batchId;
		return this.http.get(this.setEndPoint(method), this.httpOptions).pipe(
			catchError(this.handleError('getBatchStatus', batchId))
		);
	}

	public getBatchHistory(filters: any) {
		const method = 'payments/paymentterms/reports/getBatchHistory';
		return this.http.post(this.setEndPoint(method), filters, this.httpOptions).pipe(
			catchError(this.handleError('getBatchHistory', filters))
		);
	}

	public getAttempts(batchId: any) {
		const method = 'payments/paymentterms/reports/getAttempts&batch_log_id=' + batchId;
		return this.http.get(this.setEndPoint(method), this.httpOptions).pipe(
			catchError(this.handleError('getAttempts', batchId))
		);
	}

	public getCustomerHistory(debtorno: any, branchcode?: any) {
		let method = 'payments/paymentterms/reports/getCustomerHistory&debtorno=' + debtorno;
		if (branchcode) {
			method += '&branchcode=' + branchcode;
		}
		return this.http.get(this.setEndPoint(method), this.httpOptions).pipe(
			catchError(this.handleError('getCustomerHistory', { debtorno, branchcode }))
		);
	}

	public getPaymentTerms() {
		const method = 'payments/paymentterms/batch/getTerms';
		return this.http.get(this.setEndPoint(method), this.httpOptions).pipe(
			catchError(this.handleError('getPaymentTerms', {}))
		);
	}

	public loadCustomers(termCodes?: string[], agingBucket = 'overdue1') {
		let method = 'payments/paymentterms/batch/loadCustomers';
		const params: string[] = [];
		
		if (termCodes && termCodes.length > 0) {
			params.push('term_codes=' + encodeURIComponent(termCodes.join(',')));
		}
		params.push('aging_bucket=' + encodeURIComponent(agingBucket));
		
		if (params.length > 0) {
			method += '&' + params.join('&');
		}
		
		return this.http.get(this.setEndPoint(method), this.httpOptions).pipe(
			catchError(this.handleError('loadCustomers', {}))
		);
	}

	public runBatchConfigured(customers: any[]) {
		const method = 'payments/paymentterms/batch/triggerConfigured';
		return this.http.post(this.setEndPoint(method), { customers }, this.httpOptions).pipe(
			catchError(this.handleError('runBatchConfigured', { customers }))
		);
	}

	private getApi() {
		return this.config.apiServer.crossPoint;
	}

	private getApiKey() {
		return '&key=' + this.config.apiCredentials.clientId + '&userid=' + this.user.user.userid + this.getPackage();
	}

	private getPackage() {
		const p = this.globalSearchService.getSessionItem('package');
		if (p) {
			return '&package=' + p;
		} else {
			return '';
		}
	}

	private setEndPoint(method: any) {
		return this.getApi() + method + this.getApiKey();
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			return throwError(() => error);
		};
	}
}


